const ProjectsHero = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-primary/5 to-white">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-6xl font-extrabold text-dark mb-6">
          Nuestros <span className="text-primary">Proyectos</span>
        </h1>
        <p className="text-xl text-secondary max-w-3xl mx-auto leading-relaxed">
          Descubre ejemplos de trabajos realizados en Estepona, Marbella y toda la Costa del Sol. Cada proyecto refleja nuestro compromiso con la calidad y el diseño.
        </p>
      </div>
    </section>
  );
};

export default ProjectsHero;